module.exports = __webpack_public_path__ + "img/16_lisa_n.eb4c9f9d.png";